<div class="no-data-container">
  <p class="no-data">{{text}}</p>
</div>
